import React, { useEffect, useState } from "react";
import "./Selangor.css";
import { Link, useParams } from "react-router-dom";
import api from "../../../../../../services/baseUrl";
import SpecialSearch from "../../../../SpecialSearch";
import Pagination from "../../../../../../components/Pagination";
import { TiArrowUnsorted } from "react-icons/ti";
import Modal from "../../../../search/Modal";
import download from "downloadjs";
import HighlightedText from "../../../../../../components/HighlightKeyword";

export default function Selangor() {
  const [councils, setCouncils] = useState([]);
  const [stateName, setStateName] = useState("");
  const { stateId } = useParams();
  const [pageCount, setPageCount] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalResults, settotalResults] = useState(0);
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [fileUUID, setFileUUID] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [titleId, setTitleId] = useState(0);
  const [searched, setSearched] = useState(false);
  useEffect(() => {
    const fetchPbts = async () => {
      try {
        const response = await api.get(
          `/api/egazette-documents/pbts/${stateId}`
        );

        setCouncils(response.data);
      } catch (e) {}
    };

    const fetchState = async () => {
      try {
        const response = await api.get(
          `/api/egazette-documents/librariesByState/${stateId}`
        );

        setStateName(response.data.displayName);
      } catch (e) {}
    };

    fetchState();
    fetchPbts();
  }, [stateId]);

  useEffect(() => {
    const endOffset = itemOffset + limit;
    const slicedData = data.slice(itemOffset, endOffset);

    const sortedData = slicedData.sort((a, b) => {
      const dateA = new Date(a.egDocumentDto.publicationDate);
      const dateB = new Date(b.egDocumentDto.publicationDate);
      return dateB - dateA;
    });

    setCurrentItems(sortedData);
    setPageCount(Math.ceil(data.length / limit));
    settotalResults(data.length);
  }, [itemOffset, limit, data]);

  const openModal = async (uuid, egTitleId, startPage, endPage) => {
    // Step 1: Set the titleId
    setTitleId(egTitleId);

    try {
      fetchPdf(uuid, startPage, endPage);
      setFileUUID(uuid);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error in fetching startPage or PDF:", error);
    }
  };

  const fetchPdf = async (uuid, startPageNumber, endPageNumber) => {
    try {
      const response = await api.post(
        "/document/pdf/pbt",
        { fileUUID: uuid, startPageNumber, endPageNumber },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const downloadPdf = async () => {
    if (!file) return;

    const response = await api.post("/document/pdf/getFileName/pbt", {
      egTitleId: titleId,
    });

    const fileName = response.data;
    // Fetch the Blob from the file URL
    fetch(file)
      .then((res) => res.blob())
      .then((blob) => {
        // Use downloadjs to download the PDF
        download(blob, "Act " + fileName, "application/pdf");
      })
      .catch((err) => console.error("Error downloading PDF:", err));
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFile(null);
    setTitleId(0);
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % data.length;
    setItemOffset(newOffset);

    const syariahBody = document.querySelector(".egazette-search-body");
    if (syariahBody) {
      const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
    }
    setCurrentPage(event.selected);
  };

  const handleSearch = async (searchQuery) => {
    setSearched(true);
    setQuery(searchQuery.searchQuery);
    const response = await api.post(
      "/api/egazette-documents/search/meta/gazette/special",
      {
        categoryId: 1,
        type: searchQuery.keyword,
        query: searchQuery.searchQuery,
        stateId,
      }
    );

    setData(response.data);
  };

  const renderEgDocumentTitles = (egTitle) => {
    const mainTitleBM = egTitle.egDocumentDto.actTitleBM;
    const mainTitleBI = egTitle.egDocumentDto.actTitleBI;
    const titles = egTitle.egDocumentDto.titles;
    titles.sort((a, b) => {
      const aNoParts = a.no.split("-").map((num) => parseInt(num, 10));
      const bNoParts = b.no.split("-").map((num) => parseInt(num, 10));

      // Compare each part of the split 'no' to determine order
      for (let i = 0; i < Math.max(aNoParts.length, bNoParts.length); i++) {
        const aPart = aNoParts[i] || 0; // Default to 0 if part does not exist
        const bPart = bNoParts[i] || 0; // Default to 0 if part does not exist

        if (aPart !== bPart) {
          return bPart - aPart; // Compare numerically
        }
      }

      return 0; // If all parts are equal, return 0
    });
    return (
      <>
        {/* Display mainTitleBI inside HighlightedText */}
        {mainTitleBI && (
          <HighlightedText paragraph={mainTitleBI} keyword={query} />
        )}
        {titles !== undefined &&
          titles !== null &&
          titles.length > 0 &&
          titles.map((title) =>
            title.titleBI ? (
              <div key={title.egTitleId} className="egTitle-title">
                <p>{title.no}</p>

                <HighlightedText
                  paragraph={title.titleBI}
                  keyword={query}
                  onClick={() => {
                    openModal(
                      egTitle?.documentBlobDto.fileUUID,
                      egTitle.egDocumentDto.titles[0].egTitleId,
                      title.startPageNumber,
                      title.endPageNumber
                    );
                  }}
                />
                <br />
              </div>
            ) : null
          )}
        {mainTitleBM && (
          <HighlightedText paragraph={mainTitleBM} keyword={query} />
        )}

        {titles !== undefined &&
          titles !== null &&
          titles.length > 0 &&
          titles.map((title) =>
            !title.titleBI && title.titleBM ? (
              <div key={title.egTitleId} className="egTitle-title">
                <p>{title.no}</p>
                <HighlightedText
                  paragraph={title.titleBM}
                  keyword={query}
                  onClick={() => {
                    openModal(
                      egTitle?.documentBlobDto.fileUUID,
                      egTitle.egDocumentDto.titles[0].egTitleId,
                      title.startPageNumber,
                      title.endPageNumber
                    );
                  }}
                />
                <br />
              </div>
            ) : null
          )}
      </>
    );
  };
  return (
    <div className="">
      <div className="state-content">
        <SpecialSearch
          limit={limit}
          setLimit={setLimit}
          ready={true}
          query={query}
          onSearch={handleSearch}
        />
        {!searched && data.length === 0 && (
          <>
            <div className="page-title">
              {stateName.toUpperCase()} LOCAL AUTHORITY
            </div>
            <div className="page-title-line"></div>
            <div className="state-local-authority-list">
              <ol className="state-ordered-list">
                {councils.map((council, index) => (
                  <li key={index} className="state-list-item">
                    <Link to={`${council.pbtId}`}>{council.pbtName}</Link>
                  </li>
                ))}
              </ol>
            </div>
            <div style={{ height: "50px" }}></div>
          </>
        )}
        {searched && (
          <>
            <table className="selayang-table">
              <thead>
                <tr>
                  {/* <th style={{ width: "10%" }}>
                    <div className="selayang-table-header">
                      PU No.
                      <TiArrowUnsorted size={18} />
                    </div>
                  </th> */}
                  <th style={{ width: "55%" }}>
                    <div className="selayang-table-header">
                      Title/Tajuk
                      <TiArrowUnsorted size={18} />
                    </div>
                  </th>
                  <th style={{ width: "20%" }}>
                    <div className="selayang-table-header">
                      Publication Date
                      <TiArrowUnsorted size={18} />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item) => (
                  <tr key={item.egDocumentDto.documentId}>
                    {/* <td>{item.egDocumentDto.titles[0].no}</td> */}
                    {/* <td style={{ textAlign: "center" }}>
                      {item?.egDocumentDto.titles[0].no}
                    </td> */}
                    <td className="selayang-table-title">
                      {renderEgDocumentTitles(item)}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {new Date(
                        item?.egDocumentDto.publicationDate
                      ).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              handlePageClick={handlePageClick}
              pageCount={pageCount}
              currentPageNumber={currentPage}
              totalResult={totalResults}
              limit={limit}
              offset={itemOffset}
            />
          </>
        )}
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        keyword={""}
        pdf={file}
        pageNumber={1}
        fileUUID={fileUUID}
        downloadPdf={(uuid) => downloadPdf(uuid)}
      />
    </div>
  );
}
